import type { ICountry, ICountryData } from './country.types'
import { AbstractModel } from '../base'

export class Country extends AbstractModel implements ICountry {
  readonly code: string
  readonly name: string

  constructor(data: ICountryData) {
    super()

    const requiredFields: (keyof ICountryData)[] = ['code', 'name']
    this.validate(data, requiredFields)

    this.code = data.code!
    this.name = data.name!
  }
}
